import {css} from 'styled-components';
import {Z_INDEXES} from './z-indexes';

export const focusStyles = css`
  outline: 4px solid black;
  outline-offset: 2px;
  border-radius: 2px;
  z-index: ${Z_INDEXES.focus};
`;

export const invertedFocusStyles = css`
  outline: 4px solid white;
  outline-offset: 2px;
  border-radius: 2px;
  z-index: ${Z_INDEXES.focus};
`;
